const emailRegex = /[\w.-]+@[\w.-]+\.\w+/g;

export const countEmailsInString = (input: string): number => {
  if (!input) return 0;

  const isMatch = input.match(emailRegex);
  return isMatch ? isMatch.length : 0;
};
